if (!customElements.get('bundle-discount-progress')) {
  customElements.define(
    'bundle-discount-progress',
    class extends HTMLElement {
      connectedCallback() {
        this.eligibleProductIds = new Set(
          (this.dataset.eligibleProductIds || '')
            .split(',')
            .map((id) => Number(id.trim()))
            .filter(Boolean)
        );

        this.render(Number(this.dataset.count || 0));

        this.onCartUpdated = (event) => {
          const cart = event.detail?.cart;

          if (cart) {
            this.render(this.eligibleCount(cart));
          }
        };

        document.addEventListener('cart:updated', this.onCartUpdated);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }

      eligibleCount(cart) {
        if (!cart?.items) {
          return Number(this.dataset.count || 0);
        }

        const excludedVariant = Number(
          this.dataset.excludedVariant || 0
        );

        return cart.items.reduce((total, item) => {
          const productId = Number(item.product_id);
          const variantId = Number(item.variant_id || item.id);

          const isEligible =
            this.eligibleProductIds.has(productId);

          const isExcluded =
            excludedVariant && variantId === excludedVariant;

          if (!isEligible || isExcluded) {
            return total;
          }

          return total + Number(item.quantity || 0);
        }, 0);
      }

      render(count) {
        count = Math.max(0, Number(count) || 0);
        this.dataset.count = count;

        /*
         * Hide the entire progress box when the cart contains
         * no products from the eligible collection.
         */
        this.style.display = count > 0 ? '' : 'none';

        if (count === 0) {
          return;
        }

        let currentDiscount = 0;
        let nextQuantity = 2;
        let nextDiscount = 10;

        if (count >= 4) {
          currentDiscount = 25;
        } else if (count >= 3) {
          currentDiscount = 15;
          nextQuantity = 4;
          nextDiscount = 25;
        } else if (count >= 2) {
          currentDiscount = 10;
          nextQuantity = 3;
          nextDiscount = 15;
        }

        const itemsNeeded = Math.max(0, nextQuantity - count);
        const messageElement = this.querySelector(
          '[data-bundle-message]'
        );
        const fillElement = this.querySelector(
          '[data-bundle-fill]'
        );

        let message = '';

        if (count >= 4) {
          message =
            this.dataset.completeText ||
            "You've unlocked 25% off — our biggest bundle saving!";
        } else if (currentDiscount > 0) {
          message =
            this.dataset.unlockedText ||
            "You've unlocked [discount]% off — add [count] more item(s) for [next_discount]% off";

          message = message
            .replaceAll('[discount]', currentDiscount)
            .replaceAll('[count]', itemsNeeded)
            .replaceAll('[next_discount]', nextDiscount);
        } else {
          message =
            this.dataset.lockedText ||
            'Add [count] more item(s) to unlock [next_discount]% off';

          message = message
            .replaceAll('[count]', itemsNeeded)
            .replaceAll('[next_discount]', nextDiscount);
        }

        if (messageElement) {
          messageElement.textContent = message;
        }

        if (fillElement) {
          fillElement.style.width = `${Math.min(count * 25, 100)}%`;
        }

        this.querySelectorAll('[data-tier]').forEach((marker) => {
          const tier = Number(marker.dataset.tier);

          marker.classList.toggle('is-active', count >= tier);
        });
      }
    }
  );
}